(function ($) {

    $(document).ready(function () {

        if($('.section_dynamic_viewer_of_cards').length){
            new Vue({
                el: '#dynamic_viewer_of_cards',
                data: {
                    slides: 0
                },
                components: {
                    'carousel-3d': Carousel3d.Carousel3d,
                    'slide': Carousel3d.Slide
                },

                mounted: function () {
                    let self = this;

                    self.slides = slider_data.slider_data;

                }
            });

            $('.section_dynamic_viewer_of_cards .icon-arrow-left').click(function(){
                $('.carousel-3d-controls > a.prev > span').click();
            });

            $('.section_dynamic_viewer_of_cards .icon-arrow-right').click(function(){
                $('.carousel-3d-controls > a.next > span').click();
            });


            $('#dynamic_viewer_of_cards .carousel-3d-slide').live('click',function(){
                window.location = window.location.origin + '/futureforhealth/timeline/#' + $(this).data('id');
            });

        }



    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/dynamic_viewer_of_cards.es6